module.exports = __webpack_public_path__ + "static/media/arrowDownGray.cd128915.svg";